export default __webpack_public_path__ + "static/media/StefanPetrovMobile.d705db50.png";